import { Logo } from '@mgp/ui';
import { ADVERTISER_REGISTER_URL, PLAYER_URL } from '../lib/links';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border-soft bg-surface">
      <div className="mx-auto max-w-container-lg px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-9 sm:grid-cols-4">
          <div className="col-span-2 sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <Logo className="h-10 w-10" />
              <span className="font-display text-xl leading-display text-ink">Adspert</span>
            </div>
            <p className="mt-4 max-w-sm text-base text-ink-secondary">
              Advertising that earns attention — calmly, transparently, and on your
              terms.
            </p>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-caps text-ink-muted">
              For brands
            </div>
            <ul className="mt-4 space-y-2.5 text-base text-ink-secondary">
              <li>
                <a href="#services" className="transition-colors duration-fast hover:text-ink">
                  What we do
                </a>
              </li>
              <li>
                <a href="#how" className="transition-colors duration-fast hover:text-ink">
                  How it works
                </a>
              </li>
              <li>
                <a
                  href={ADVERTISER_REGISTER_URL}
                  className="transition-colors duration-fast hover:text-ink"
                >
                  Start a campaign
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-caps text-ink-muted">
              More
            </div>
            <ul className="mt-4 space-y-2.5 text-base text-ink-secondary">
              <li>
                <a href="#faq" className="transition-colors duration-fast hover:text-ink">
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@adspert.io"
                  className="transition-colors duration-fast hover:text-ink"
                >
                  Contact
                </a>
              </li>
              <li>
                <a href={PLAYER_URL} className="transition-colors duration-fast hover:text-ink">
                  Looking to play?
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-border-soft pt-7 text-sm text-ink-muted sm:flex-row sm:items-center">
          <span>&copy; {year} Adspert. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <a href="/privacy" className="transition-colors duration-fast hover:text-ink">
              Privacy
            </a>
            <a href="/terms" className="transition-colors duration-fast hover:text-ink">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
